"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_producer_1 = require("./http-producer");
var log_producer_1 = require("./log-producer");
var Monorail = /** @class */ (function () {
    function Monorail(producer) {
        this.producer = producer;
    }
    Monorail.createHttpProducer = function (config) {
        return new Monorail(config.production
            ? new http_producer_1.HttpProducer(http_producer_1.HttpProducer.PRODUCTION_ENDPOINT)
            : new http_producer_1.HttpProducer(http_producer_1.HttpProducer.DEVELOPMENT_ENDPOINT));
    };
    Monorail.createHttpProducerWithEndpoint = function (edgeEndpoint) {
        return new Monorail(new http_producer_1.HttpProducer(edgeEndpoint));
    };
    Monorail.createLogProducer = function (config) {
        return new Monorail(new log_producer_1.LogProducer(config.debugMode));
    };
    Monorail.prototype.produce = function (monorailEvent) {
        return this.producer.produce(monorailEvent);
    };
    return Monorail;
}());
exports.Monorail = Monorail;
